import MatLink from "@material-ui/core/Link";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

export default function Link(props) {
  return <MatLink component={RouterLink} {...props} />;
}
